import ActionBar from './ActionBar.connect';

export default ActionBar;
